<nav class="navbar navbar-expand-lg navbar-dark bg-dark" *ngIf="authService.isAuthenticated()">
    <div class="container-fluid">
        <a class="navbar-brand" href="/offers"> Famulus</a>
        <!--<img class="logo" src="/assets/famulus_logo.png" alt="Famulus">-->
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive"
            aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-users-cog"></i>Customers
                    </a>
                    <div class="dropdown-menu " aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="/clients"><i class="fa fa-user-friends"></i> All</a>
                        <a class="dropdown-item" href="/clients/create"><i class="fa fa-user-plus"></i> Insert</a>
                    </div>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" href="companies">
                        Companies
                    </a>
                </li> -->
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-server"></i> Hardware
                    </a>
                    <div class="dropdown-menu " aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="hardware/printers"><i class="fa fa-print"></i>
                            Printers</a>
                        <a class="dropdown-item" href="hardware/devices"><i class="fa fa-mobile-alt"></i> Devices</a>
                        <a class="dropdown-item" href="hardware/routers"><i class="fa fa-wifi"></i> Routers</a>
                    </div>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="price-lists/all">
                        <i class="fa fa-funnel-dollar"></i> Price Lists
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="events/all">
                        <i class="fa fa-calendar"></i> Events
                    </a>
                </li>
                <!-- <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownClients" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-calendar"></i> Events
                    </a>
                    <div class="dropdown-menu " aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="events/all"><i class="fa fa-calendar-week"></i>All</a>
                        <a class="dropdown-item" href="events/request"><i class="fa fa-calendar-plus"></i>Request</a>
                        <a class="dropdown-item" href="events/calendar"><i class="fa fa-calendar-alt"></i>Calendar</a>
                    </div>
                </li> -->
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-scroll"></i> Offers
                    </a>
                    <div class="dropdown-menu " aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="offers"><i class="fa fa-list"></i>All</a>
                        <a class="dropdown-item" href="offers/create"><i class="fa fa-plus"></i>Create</a>
                    </div>
                </li>
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" role="button"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-chart-line"></i> Statistics
                  </a>
                  <div class="dropdown-menu " aria-labelledby="navbarDropdown">
                      <a class="dropdown-item" href="statistics/customers"><i class="fa fa-user-friends"></i>Customers</a>
                      <a class="dropdown-item" href="statistics/events"><i class="fa fa-calendar"></i>Events</a>
                  </div>
                </li>
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" role="button"
                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-robot"></i> Agents
                  </a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" href="agents/analytics"><i class="fa fa-chart-area"></i>Analytics</a>
                    <a class="dropdown-item" href="agents/configuration"><i class="fa fa-cogs"></i>Configuration</a>
                    <a class="dropdown-item" href="agents/markdowns"><i class="fa fa-file-invoice"></i>Markdowns</a>
                    <a class="dropdown-item" href="agents/conversations"><i class="fa fa-user-friends"></i>Conversations</a>
                  </div>
                </li>
                <!--
                <li class="nav-item">
                    <a class="nav-link" href="blogs">
                        <i class="fa fa-file"></i> Blogs
                    </a>
                </li>
                -->
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle"role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-cogs"></i> Settings
                    </a>
                    <div class="dropdown-menu " aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="settings/locations"><i class="fa fa-home"></i>Locations</a>
                    </div>
                </li>
            </ul>
            <ul class="navbar-nav ml-auto">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Profile
                    </a>
                    <div class="dropdown-menu " aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="#" (click)="logout()">Logout</a>
                    </div>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="padding: 7px;">
                        <a>
                            <img [src]="'/assets/flag/' + currentLanguage.flag +'.png'">
                        </a>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" *ngFor="let l of languages" (click)="changeLanguage(l)">
                            <img [src]="'/assets/flag/' + l.flag +'.png'">
                        </a>
                    </div>
                </li>
            </ul>
            <!-- <app-request-event-modal></app-request-event-modal>
      <app-client-company-modal [searchIcon]="true"></app-client-company-modal> -->
        </div>
    </div>
</nav>
